import React from 'react'

import { Pressable, Stack, XStack } from '@zet/design-system'

import { B16 } from '../typography'

interface CustomSelectOptionProps {
  value: string
  displayText: string
  selectedValue: string
  onSelect: (value: string) => void
}

export const CustomSelectOption: React.FC<CustomSelectOptionProps> = ({
  value,
  displayText,
  selectedValue,
  onSelect,
}) => {
  const isSelected = selectedValue === displayText

  return (
    <Pressable
      onPress={() => onSelect(value)}
      className="mt-3 w-full rounded-lg py-1 bg-transparent"
    >
      <XStack className="justify-between flex-row items-center">
        <B16 className="text-black">{displayText}</B16>
        <Stack
          className={`rounded-full h-[16px] w-[16px] items-center justify-center ${
            isSelected
              ? 'border-[#CEA15A] border-[3px]'
              : 'border-[#1E1A1452] border-[2px]'
          }`}
        >
          {isSelected && (
            <Stack className="bg-black rounded-full h-[10px] w-[10px]" />
          )}
        </Stack>
      </XStack>
    </Pressable>
  )
}
